import { IconMainMenuTraces } from "@suse-o11y/icons";
import React from "react";

import { useNavigateToLink } from "../../components/react/link";
import { TRACES_PATH } from "../../routes/Routes";

import { MainMenuItemLayout } from "./MainMenuItemLayout";

export const MainMenuItemTraces: React.FC = () => {
	const link = useNavigateToLink(TRACES_PATH, {
		search: ["timeRange", "timestamp", "detachedFilters"],
	});

	return <MainMenuItemLayout icon={<IconMainMenuTraces height={18} width={18} />} label="Traces" to={link} />;
};
